import ProtectedRoute from "../../auth/ProtectedRoute";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";

import { useAuth } from "../../auth/FirebaseAuth";
import { useAppContext } from "../AppContext";
import { getDocDataById, getDocDataByRef } from "../../models/DataFunctions";
import { Spin } from "antd";
import { Loading } from "../../pages/Loading";
import Home from "../../pages/home/Home";
import Carnets from "../../pages/carnets/Carnets";
import Partners from "../../pages/Partners";
import Recharge from "../../pages/Recharge";
import Parameters from "../../pages/parameters/Parameters";
import NewCarnet from "../../pages/carnets/NewCarnet";
import NewPartner from "../../pages/NewPartner";
import { CarnetPage } from "../../pages/carnets/CarnetPage";
import Partner from "../../pages/Partner";
import { Org, Workspace } from "../../types/org";
import ModifyPartner from "../../pages/ModifyPartner";
import Bibliotheque from "../../pages/Bibliotheque";
import Orgs from "../../pages/admin/Orgs";
import OrgDetail from "../../pages/admin/Org";

const NotFound = React.lazy(() => import("../../pages/NotFound"));
type OldRoutesProps = {
  navigateWorkspace: any;
  actualpage: any;

  userData: any;
  orgData: any;
  handleLoginAs: any;
  workspaceData?: Workspace | null;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
  setShowProtocole?: (page: number) => void; // Optional prop to control protocol visibility
  version?: string;
  masterData?: Org | null;
};

const OldRoutes = ({
  navigateWorkspace,
  actualpage,
  userData,
  orgData,
  workspaceData,
  handleLoginAs,
  handleClickVariant,
  setShowProtocole,
  masterData,
  version,
}: OldRoutesProps) => {
  const location = useLocation();

  const navigate = useNavigate(); // Hook to handle navigation
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  function overrideId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("imp");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }

  function workspaceId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("workspace");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }
  const show_favoris = useState(Math.random() > 0.5)[0];

  if (loading) {
    return (
      <div className="h-screen flex flex-col gap-2 bg-white fixed w-screen items-center justify-center">
        <Loading></Loading>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full ">
      {<div className="mt-6"></div>}

      <Routes>
        <Route
          path="/home"
          element={
            <Home
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
              workspaceData={workspaceData ?? undefined}
              overrideId={overrideId() ?? undefined}
              handleClickVariant={handleClickVariant}
            />
          }
        />
        <Route
          path="/newcarnet"
          element={
            <NewCarnet
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
            />
          }
        />
        <Route
          path="/carnets"
          element={
            <Carnets
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
              overrideId={overrideId() ?? undefined}
              workspaceData={workspaceData ?? undefined}
            />
          }
        />{" "}
        <Route
          path={"/carnet/:id"}
          element={
            <CarnetPage
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
            />
          }
        />
        <Route
          path="/partners"
          element={
            <Partners
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
              overrideId={overrideId()}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/newpartner"}
          element={
            <NewPartner
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData ?? null}
            />
          }
        />{" "}
        <Route
          path={"/modifypartner/:id"}
          element={
            <ModifyPartner
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData ?? null}
            />
          }
        />{" "}
        <Route
          path={"/partner/:id"}
          element={
            <Partner
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData ?? null}
            />
          }
        />
        <Route
          path="/recharge"
          element={
            <Recharge
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
              workspaceData={workspaceData}
              overrideId={overrideId()}
            />
          }
        />
        <Route
          path={"/parameters"}
          element={
            <Parameters
              page="Account"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId() ?? undefined}
              workspaceData={workspaceData}
              masterData={masterData}
            />
          }
        />
        <Route
          path={"/account"}
          element={
            <Parameters
              page="Account"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId() ?? undefined}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/organisation"}
          element={
            <Parameters
              page="Organisation"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId() ?? undefined}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path={"/tags"}
          element={
            <Parameters
              page="Tags"
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId() ?? undefined}
              workspaceData={workspaceData}
            />
          }
        />
        <Route
          path="/bibliotheque"
          element={
            <Bibliotheque
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              overrideId={overrideId() ?? undefined}
              workspaceData={workspaceData ?? undefined}
            />
          }
        />
        <Route
          path="/admin/orgs"
          element={
            <Orgs
              navigateWorkspace={navigateWorkspace}
              userData={userData}
              orgData={orgData}
            />
          }
        />
        <Route
          path="/admin/org/:id"
          element={
            <OrgDetail
              userData={userData}
              orgData={orgData}
              navigateWorkspace={navigateWorkspace}
              handleLoginAs={handleLoginAs}
            />
          }
        />
        <Route
          path="*"
          element={<NotFound navigateWorkspace={navigateWorkspace} />}
        />
      </Routes>
    </div>
  );
};

export default OldRoutes;
